<template>
  <div class="blog">
    <h2 class="blog__heading">Blog</h2>
    <transition-group name="insert-blog" v-if="blogLinks" tag="div" class="blog__transition">
      <BlogLink v-for="(item, index) in blogLinks" :key="index" :item="item"></BlogLink>
    </transition-group>
    <div class="blog__show-more">
      <a href="/blog" class="btn btn-primary">Včechny články</a>
    </div>
  </div>
</template>

<script>
import BlogLink from "@/components/BlogLink";

export default {
  data() {
    return {
    };
  },
  components: {
    BlogLink,
  },
  props: ["blogLinks"],
};
</script>
<style>
.blog, .blog > .blog__transition {
  grid-column: span 2;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 48px;
}

.blog__heading {
  grid-column: span 2;
  text-align: center;
}

.blog__show-more {
  grid-column: span 2;
  text-align: right;
}

.blog__link {
  transition: all 2s;
}

.insert-blog-enter:nth-child(odd),
.insert-blog-leave-to:nth-child(odd) {
  opacity: 0;
  transform: translate(-30%, 0);
}
.insert-blog-enter:nth-child(even),
.insert-blog-leave-to:nth-child(even) {
  opacity: 0;
  transform: translate(30%, 0);
}

.insert-blog-leave-active {
  position: absolute;
}
</style>
